import { RoleDoc } from '../../../modules/core/types';

const publicRole: RoleDoc = {
  schema: {},
};

export default publicRole;
